import type { CoreState } from '../../../core/store/core.reducer';
import type { LoginUser } from './login.reducer';


export function isLoginValidating(state: CoreState) {
  return state.login.validating;
}

export function getLoginJWTToken(state: CoreState) {
  return state.login.jwt;
}

export function getLoginUser(state: CoreState): LoginUser {
  return state.login.loginUser;
}

export function getLoginError(state: CoreState) {
  return state.login.error;
}

export function getLoginErrorStr(state: CoreState) {
  return state.login.error_str;
}

export function getUser(state: CoreState) {
  return state.login.user;
}

export function isTopBarVisible(state: CoreState) {
  return state.login.jwt === null || state.login.ui === 'default';
}

export function isGoogleSignInVisible(state: CoreState) {
  return !state.login.extra || !state.login.extra.disable_google_sign_in;
}

export function isMicrosoftSignInVisible(state: CoreState) {
  return !state.login.extra || !state.login.extra.disable_microsoft_sign_in;
}

export function getLoginDescription(state: CoreState) {
  return (state.login.extra && state.login.extra.description) ? state.login.extra.description : '';
}

export function getWelcomeScreenState(state: CoreState) {
  return state.login.welcomeScreen;
}

export function getEmailVerificationScreenState(state: CoreState) {
  return state.login.emailVerificationScreen;
}

export function isMobileSignInEnabled(state: CoreState) {
  return state.login.mobileSignInEnabled;
}
